import React, { Fragment } from 'react';
import {
    Header,
    Grid, Segment,
    Button,
    Icon, Form, Dropdown, Table, Popup, Loader
} from 'semantic-ui-react';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';


// import styled, { keyframes } from 'styled-components';
// import { fadeIn } from 'react-animations';
import { Link, Redirect } from 'react-router-dom';
import ActivePollList from '../AdminPoll/PollTabs/ActivePollList';
import moment from 'moment';
import PropTypes from 'prop-types';
import StudentLockForm from '../../StudentService/StudentOverview/StudentLockForm';
import SearchTableData from "../../util/SearchTableData";
import ReactExport from 'react-data-export';
import PaginationFront from "../../util/PaginationFront";

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;
const { ExcelColumn } = ReactExport.ExcelFile;


export default class PollListTable extends React.Component {
    rowRedirect;
    constructor(props) {
        super(props);
        this.state = {
            results: [],

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            excelData: this.props.polls.map((el, index) => ([
                { value: (index + 1) + '.' },
                { value: el.name },
                { value: el.questionnaireType.name },
                { value: el.activationDate },
                { value: el.endDate }
            ]))
        };
        this.getResults = this.getResults.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
    }

    componentDidMount() {
        localStorage.removeItem('pollType')
    }

    getResults(results) {
        if (results.length === 0) {
            this.setState({
                results: [],
                excelData: this.props.polls.map((el, index) => ([
                    { value: (index + 1) + '.' },
                    { value: el.name },
                    { value: el.questionnaireType.name },
                    { value: el.activationDate },
                    { value: el.endDate }
                ]))
            });
        }
        else {
            this.setState({
                results,
                excelData: results.map((el, index) => ([
                    { value: (index + 1) + '.' },
                    { value: el.name },
                    { value: el.questionnaireType.name },
                    { value: el.activationDate },
                    { value: el.endDate }
                ]))
            });
        }
        this.handlePaginationChange({}, { activePage: 1 })
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.props.polls;
    }
    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })

    render() {
        // const FadeIn = styled.div`animation: 1s ${keyframes`${fadeIn}`}`;
        if (this.state.showResults === true) {
            return <Redirect push to={{ pathname: this.props.rowRedirect }} />;
        }
        let { polls, firstButtonText, firstButtonLink, firstAltButtonText, firstAltButtonLink } = this.props;

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        const multiDataSet = [
            {
                columns: [
                    { title: 'R. br.', width: { wpx: 50 } },
                    { title: 'Naziv anketnog upitnika', width: { wpx: 700 } },
                    { title: 'Tip', width: { wpx: 250 } },
                    { title: 'Datum objave studentima', width: { wpx: 200 } },
                    { title: 'Datum isteka', width: { wpx: 200 } },
                ],
                data: this.state.excelData,
            }
        ];

        return (

            <Fragment>

                {this.state.loading ? <Loader active inline="centered" /> :
                    polls.length ? <Table celled selectable compact>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan={17} >
                                    <Grid column={2} stackable>
                                        <Grid.Column width={14}>
                                            <SearchTableData profMozilla data={this.props.polls} getResults={this.getResults} filterItem={['name', 'type']} />
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign="center">
                                            <ExcelFile filename={'Završene ankete'} element={<Popup
                                                trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                    <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                    <Button.Content visible>
                                                        Excel
                                                    </Button.Content>
                                                </Button>}
                                                content="Preuzmi spisak u Excel-u"
                                                hideOnScroll
                                                position="top center"
                                            />}>
                                                <ExcelSheet dataSet={multiDataSet} name={'Ankete'} />
                                            </ExcelFile>

                                        </Grid.Column>
                                    </Grid>
                                </Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>
                                <Table.HeaderCell width={1}>R. br.</Table.HeaderCell>
                                <Table.HeaderCell colSpan={6}>Naziv anketnog upitnika</Table.HeaderCell>
                                <Table.HeaderCell colSpan={3}>Tip</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum objave studentima</Table.HeaderCell>
                                <Table.HeaderCell colSpan={2}>Datum isteka</Table.HeaderCell>
                                {this.props.active ? <Table.HeaderCell colSpan={2} >Datum objave rezultata</Table.HeaderCell>
                                    : <Table.HeaderCell colSpan={3} ></Table.HeaderCell>}
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {currentPosts.map((el, index) =>
                            (<Table.Row
                                key={index}
                                onClick={(e) => {
                                    let poll = {
                                        pollId: el.id,
                                        pollName: el.name,
                                        pollType: el.questionnaireType.id,
                                        pollTypeKey: el.questionnaireType._key,
                                        pollStatus: el.questionnaireStatus.id,
                                        showAddQuestion: false
                                    };
                                    localStorage.setItem('poll', JSON.stringify(poll));
                                    this.setState({ showResults: true });
                                }}
                            >
                                <Table.Cell verticalAlign="middle">
                                    {index + 1}.
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={6}>
                                    {el.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={3}>
                                    {el.questionnaireType.name}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {el.activationDate}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" colSpan={2}>
                                    {el.endDate}
                                </Table.Cell>
                                {this.props.active ?
                                    <Table.Cell verticalAlign="middle" colSpan={2}>
                                        {moment(el.statisticsActivationDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    : <Table.Cell verticalAlign="middle" textAlign="center" colSpan={3}>
                                        {/* link */}
                                        <Link to={{
                                            // pathname: '',
                                            pathname: el.questionnaireType._key === 'academic staff evaluation' ? firstButtonLink : firstAltButtonLink,
                                        }}
                                        >
                                            <Button
                                                onClick={() => {
                                                    let poll = {
                                                        pollId: el.id,
                                                        pollName: el.name,
                                                        pollType: el.questionnaireType.id,
                                                        pollTypeKey: el.questionnaireType._key,
                                                        pollStatus: el.questionnaireStatus.id,
                                                        showAddQuestion: false
                                                    };
                                                    localStorage.setItem('poll', JSON.stringify(poll));
                                                }}

                                                basic="true"
                                                color="blue"
                                                size="small"
                                            > {el.questionnaireType._key === 'academic staff evaluation' ? firstButtonText : firstAltButtonText}
                                            </Button>

                                        </Link>
                                    </Table.Cell>}
                            </Table.Row>))}
                        </Table.Body>
                    </Table> : <div>{this.props.active ? 'Trenutno nema aktivnih anketnih upitnika na vašoj organizacionoj jedinici.' : 'Trenutno nema arhiviranih anketnih upitnika na vašoj organizacionoj jedinici.'}</div>
                }
                {currentPosts.length > 0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
            </Fragment>
        );
    }
}
// PollListTable.propTypes = {
//     // eslint-disable-next-line react/require-default-props
//     polls: PropTypes.array(),
//     rowRedirect: PropTypes.number,
// };


// WEBPACK FOOTER //
// ./src/views/Poll/Util/PollListTable.js